import {useMemo, useState} from 'react';
import {useGoodsDetailContext} from "../../../../../../reducer/moduleReducer/goodsDetail";
import Magnifier from "react-magnifier";


export default function LeftDetailBlock() {
  const { state } = useGoodsDetailContext();
  const [imgActive, setImgActive] = useState(0);
  const { detail } = state;
  
  const imgs = useMemo(() => {
    return detail.imageList || [];
  }, [detail]);
  
  return (
    <div className="flex-1 flex">
      <div className="flex flex-col mt-[12%] mr-[12px]">
        {
          imgs.map((item, i) => (
            <i key={i}
               onClick={() => setImgActive(i)}
               style={{ backgroundColor: i === imgActive ? '#333' : '#fff' }}
               className="cursor-pointer border border-[#666] w-[12px] h-[12px] rounded-full mb-[12px]"/>
          ))
        }
      </div>
      <div className="flex-1">
        {/*<img src={item.fileUrlView}/>*/}
        {/* <img src={imgs[imgActive].fileUrlView} className="w-[100%]"/> */}
        <Magnifier
          src={
            imgs[imgActive].fileUrlView
          }
          width={500}
          mgWidth={300}
          mgHeight={300}
          zoomFactor={1.5}
          className="w-[100%]"
          style={{height: 500, objectFit: 'cover'}}
        />
      </div>
      <div className="w-[150px] ml-[15px]">
        {
          imgs.map((item, i) => (
            <div className="cursor-pointer mb-[15px]"
                 onClick={() => setImgActive(i)}
                 key={i}>
              <img src={item.fileUrlView}/>
            </div>
          ))
        }
      </div>
    </div>
  );
}
